import { type GetCampaign_me_adObject } from "@north-beam/nb-client-side";

import { type Level } from "../../types";
import { type FlyoutConfig } from "../flyout";

import { TableSection } from "./table-section";
import { TopLevel } from "./top-level";

interface Props {
  adObject: GetCampaign_me_adObject;
  adObjectLevel: Level;
  config: FlyoutConfig;
  onChangeAdObject(id: string): void;
}

export const Performance = ({
  adObject,
  adObjectLevel,
  config,
  onChangeAdObject,
}: Props) => {
  return (
    <>
      <TopLevel
        adObjectLevel={adObjectLevel}
        topLevel={adObject.topLevel}
        config={config}
      />
      {adObjectLevel !== "ad" && (
        <TableSection
          adObject={adObject}
          adObjectLevel={adObjectLevel}
          config={config}
          onClickAdObject={onChangeAdObject}
        />
      )}
    </>
  );
};
